import React from "react";
import { Box, Tooltip, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { PiMotorcycleFill } from "react-icons/pi";

// Columna "Resultado": ícono de moto si idTipoCliente es 13 (Yupana), si no
// muestra check/x según `data.resultado`, con badge de motivo de continuidad.
export default function CeldaResultado({ data, handlePopoverOpen }) {
  return (
    <TableCell align="center">{String(data.idTipoCliente) === "13" ? (
      <Tooltip title="Moto" arrow placement="top">
        <Box
          component="span"
          sx={{ position: "relative", display: "inline-flex", ml: 1, verticalAlign: "middle" }}
        >
          <PiMotorcycleFill size={28} color="#22c55e" />
          {data.idMotivoContinuidad > 0 && (
            <Box
              sx={{
                position: "absolute",
                top: -6,
                right: -6,
                backgroundColor: "#9c154d",
                borderRadius: "50%",
                fontSize: 12,
                width: 10,
                height: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold",
                zIndex: 1,
              }}
            />
          )}
        </Box>
      </Tooltip>
    ) : data.resultado === 0 ? (
      // Ícono ❌ cuando resultado === 0
      <Box
        sx={{
          position: "relative",
          width: 28,
          height: 28,
          display: "inline-block",
        }}
      >
        <HighlightOffIcon
          sx={{
            color: "#DC3545",
            position: "absolute",
            top: 0,
            left: 0,
            width: 28,
            height: 28,
          }}
        />
        {data.idMotivoContinuidad > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              backgroundColor: "#9c154d",
              borderRadius: "50%",
              fontSize: 12,
              width: 10,
              height: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              zIndex: 1,
            }}
          />
        )}
      </Box>
    ) : data.resultado === 1 ? (

      <Box sx={{ position: "relative", display: "inline-block", width: 28, height: 28 }}>
        <CheckCircleIcon sx={{ color: "#28A745", fontSize: 28 }} />
        {data.idMotivoContinuidad > 0 && (
          <Box
            sx={{
              position: "absolute",
              top: -6,
              right: -6,
              backgroundColor: "#9c154d",
              borderRadius: "50%",
              fontSize: 12,
              width: 10,
              height: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "bold",
              zIndex: 1,
            }}
          />

        )}
      </Box>
    ) : null}

      {/* Ícono de acciones */}
      <span>
        <MoreVertIcon
          onClick={(event) => handlePopoverOpen(event, 7, data)}
          style={{ cursor: "pointer" }}
        />
      </span>

    </TableCell>
  );
}
